import { render, staticRenderFns } from "./DashWallCardList.vue?vue&type=template&id=056d993c&"
import script from "./DashWallCardList.vue?vue&type=script&lang=ts&"
export * from "./DashWallCardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports